/* eslint-disable
    import/default,
    import/named,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import CompanyConstants from 'constants/CompanyConstants'
import * as CookieHelpers from 'utils/CookieHelpers'
const CONVERSATION_COLLAPSE_STATE_COOKIE = 'conversationCollapseStateByCompanyId'
import { pickObjects } from 'utils/StatePicker'

const CompanyStore = Marty.createStore({
  id: 'CompanyStore',

  getInitialState() {
    return {
      companiesById: {}
    }
  },

  handlers: {
    fetchCompanyDone: CompanyConstants.COMPANY_FETCH_DONE,
    fetchCompanyListDone: CompanyConstants.COMPANY_LIST_FETCH_DONE,

    setCompanyFromPusher: CompanyConstants.SET_COMPANY_FROM_PUSHER,
    updateCompanyDone: CompanyConstants.COMPANY_UPDATE_DONE
  },

  getOrFetchCompanyList() {
    return this.fetch({
      id: 'fetchCompanyList',
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally() {
        if (this.hasAlreadyFetched('fetchCompanyList')) {
          return this.state.companiesById
        }
      },
      remotely() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        return this.app.queries.CompanyQueries.fetchCompanyListForOrgId(orgId)
      }
    })
  },

  fetchCompanyListDone(companies) {
    const companiesById = _.cloneDeep(this.state.companiesById)
    _.each(companies, company => companiesById[company.id] = company)
    return this.setState({ companiesById })
  },

  getCompaniesById() {
    return this.state.companiesById
  },

  getCompany(companyId) {
    if (companyId > 0) {
      return this.state.companiesById[companyId]
    } else {
      return false
    }
  },

  getOrFetchCompany(companyId) {
    return this.fetch({
      id: `fetchCompany${ companyId }`,
      locally() {
        return this.getCompany(companyId)
      },
      remotely() {
        return this.app.queries.CompanyQueries.fetchCompany(companyId)
      }
    })
  },

  fetchCompanyDone(companyId, company) {
    return this.setCompany(company)
  },

  fetchCompanies(companyIds) {
    return this.fetch({
      id: `fetchCompanies${ companyIds }`,
      locally() {
        return pickObjects(this.state.companiesById, companyIds)
      },
      remotely() {
        const idsNeedsFetching = _.filter(companyIds, companyId => {
          return (this.state.companiesById[companyId] == null)
        })
        return this.app.queries.CompanyQueries.fetchCompaniesByIds(idsNeedsFetching)
      }
    })
  },

  setCompanyFromPusher(company) {
    return this.setCompany(company)
  },

  updateCompanyDone(company) {
    return this.setCompany(company)
  },

  setCompany(company) {
    const companiesById = _.cloneDeep(this.state.companiesById)
    companiesById[company.id] = company
    return this.setState({ companiesById })
  }
})

export default CompanyStore



// WEBPACK FOOTER //
// ./src/scripts/stores/CompanyStore.js